<!--分页-->
<template id="page">
    <div class="container">
      <ul class="page">
        <li v-for="(item,$index) in Pages" @click="go(item)" :class="item==curPage?'active':''">{{item}}</li>
      </ul>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        curPage: 1,
        jumpState: false, //后续保留参数
        jumpPage: null, //跳转页码
      }
    },
    props: {
      defultPage: { //默认显示页数
        type: Number,
        default: 5
      },
      limit: { //显示条数
        type: Number,
        default: 20
      },
      total: { //数据总数
        type: Number,
      },
      defultJump: { //默认跳转页
        type: Number,
        default: 1
      }
    },
    computed: {
      pageCount() {
        return Math.ceil(this.total / this.limit)
      },
      Pages() {
        var cur = this.curPage; //当前页码
        var pageall = this.pageCount; //共多少页
        var defultPage = this.defultPage;
        var array = [];
        var start = parseInt((cur - 1) / defultPage) * defultPage + 1;
        var end;
        //结束页码
        if (start + defultPage > pageall) {
          end = pageall + 1
        } else {
          end = start + defultPage;
        }

        // 判断结束边界
        if (cur > pageall) {
          cur = this.curPage = pageall;
          start = parseInt((cur - 1) / defultPage) * defultPage + 1;
          end = pageall + 1
        }

        //判断开始边界
        if (cur < 1) {
          this.curPage = 1
          start = 1;
          if (start + defultPage > pageall) {
            end = pageall + 1
          } else {
            end = start + defultPage;
          }
        }
        for (var i = start; i < end; i++) {
          array.push(i)
        }
        return array
      }
    },
    components: {},
    methods: {
      go(index) {
        this.curPage = index
        this.$emit('change', this.curPage); //父组件通过change获取当前页
      },
      prev() {
        this.curPage--;
        this.go(this.curPage);
      },
      next() {
        this.curPage++;
        this.go(this.curPage);
      },
      jump() {
        this.go(this.jumpPage);
      },

      /*
       *可以根据首页/尾页
       *自行扩展
       *跳转首尾
       */
      first() { //首页
        this.go(1);
      },
      last() { //尾页
        this.go(this.pageCount);
      }
    },
    created() {
      this.go(this.defultJump);
    },
  }
</script>
<style scoped>

  .container {
    width: 100%;
    display: flex;
  }
  .page {
    display: flex;
    justify-content: center;
  }
  .page li {
    height:2.447916vw;
    width:2.447916vw;
    margin-left: 0.833333vw;
    font-size: 1.666666vw;
    font-family: 'PingFang SC';
    color: #666666;
    text-align: center;
    border: 0.052083vw solid rgba(216, 216, 216, 0.8);
  }

  .active{
    height:2.447916vw;
    width:2.447916vw;
    margin-left: 0.833333vw;
    font-size: 1.666666vw;
    font-family: 'PingFang SC';
    color: #333333;
    text-align: center;
    background: rgba(216, 216, 216, 0.5);
  }


    .jump-box {
      padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/custom/page.vue